// import iconCat1 from '../../assets/icons/icon_run_cat.png';
import fireWaterIcon from '../../assets/icons/fire_water.png';
import { useNavigate } from 'react-router';

const PLAYGROUND_SCROLL_KEY = 'playground-scroll-top';

const stackingItems = [
  // {
  //   id: 'cat-running',
  //   image: iconCat1,
  //   imageAlt: 'icon_cat 1',
  //   title: '캣러닝',
  //   description: '우사인냥이가 되어보자 !',
  //   point: 300,
  // },
  {
    id: 'fire-water',
    image: fireWaterIcon,
    imageAlt: 'fire_water',
    title: '물냥불냥',
    description: '다른걸 찾으면 끝 !',
    point: '1,000',
    path: '/mulnyang-bulnyang',
  },
];

function PlaygroundStackingCardItem({ image, imageAlt, title, description, point, onClick }) {
  return (
    <div
      className={`w-full rounded-[10px] bg-white py-4 pl-2.5 pr-5 shadow-[0px_6px_16px_0px_rgba(0,0,0,0.10)] inline-flex items-center justify-between ${
        onClick ? 'cursor-pointer' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-start gap-2.5">
        <div className="relative h-12 w-12">
          <div className="h-12 w-12 rounded-[10px] bg-[#FFF0E8]" />
          <img src={image} alt={imageAlt} className="absolute left-1 top-1 h-10 w-10 rounded-[10px] object-cover" />
        </div>

        <div className="inline-flex w-40 flex-col items-start justify-start gap-1">
          <div className="self-stretch justify-center text-base font-bold text-gray05 font-['Pretendard']">{title}</div>
          <div className="self-stretch justify-center text-sm font-medium text-gray03 font-['Pretendard']">
            {description}
          </div>
        </div>
      </div>

      <div className="inline-flex w-16 flex-col items-end justify-start gap-[3px]">
        <div className="inline-flex w-20 items-center justify-end gap-1">
          <div className="justify-center">
            <span className="text-base font-extrabold text-gray05 font-['Pretendard']">{point} </span>
            <span className="text-sm font-bold text-gray05 font-['Pretendard']">P</span>
          </div>
        </div>

        <div className="inline-flex items-center justify-center gap-2.5 rounded-[5px] bg-background01 px-2 py-1">
          <div className="justify-center text-[10px] font-bold text-primary-blue font-['Pretendard']">최대보상</div>
        </div>
      </div>
    </div>
  );
}

function PlaygroundStackingCardList() {
  const navigate = useNavigate();
  const saveAndNavigate = (path) => {
    const pageContainer = document.getElementsByClassName('page-container')[0];
    if (pageContainer) {
      const top = Math.max(pageContainer.scrollTop ?? 0, window.scrollY || 0);
      sessionStorage.setItem(PLAYGROUND_SCROLL_KEY, String(top));
    }
    navigate(path);
  };

  return (
    <div className="flex flex-col gap-2.5 px-2">
      {stackingItems.map((item) => (
        <PlaygroundStackingCardItem
          key={item.id}
          image={item.image}
          imageAlt={item.imageAlt}
          title={item.title}
          description={item.description}
          point={item.point}
          onClick={item.path ? () => saveAndNavigate(item.path) : undefined}
        />
      ))}
    </div>
  );
}

export default PlaygroundStackingCardList;
